import React from "react";
import RangeSelector from "../components/RangeSelector";
import ReportFilter from "../components/ReportFilter";

const EfficiencyReport = () => {
  return (
    <section className="content">
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <ReportFilter></ReportFilter>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12">
          <div className="card border shadow border-white">
            <div className="card-body">
              <div>
                <div
                  className="row col-lg-12 d-flex flex-row mr-4 p-2 justify-content-center align-items-center align-items-center"
                  id="productiondata"
                >
                  <RangeSelector></RangeSelector>
                  Chart Appears here
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { EfficiencyReport };
